// extracted by mini-css-extract-plugin
export default {"text":"XUaLG","link":"hKvr_"};